import React from 'react';
import { Link } from 'react-router-dom';
import GreenCheck from '../../../images/new_checkmark.png';

const ADConfirmation = () => {
	const rkLogo = '/images/rk-logo-alt.svg';

	return (
		<div id="client-signup">

			<nav className="navbar navbar-light bg-light">
				<div className="navbar-brand">
					<img src={rkLogo} alt="organization logo" />
				</div>
			</nav>

			<div className="container">
				<div className="row">
					<div className="col-sm-12">
						<div className="row">
							<img className="img-responsive center-image" src={GreenCheck} alt="checkmark" />
						</div>
						<div className="row form-group text-center"><h1 className="col-sm-12"><strong>Account Created</strong></h1></div>
						<div className="row text-center">
							<div className="col-sm-12">
								Thank you for creating your account. You now have access to your business&nbsp;
								<br className="hidden-xs" />
								portal to view, request, and pay your jobs.
							</div>
							<div className="col-sm-12">
								<br />
								<Link to="/overview">View Your Business Portal</Link>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	);
};

export default ADConfirmation;
